"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketsController = void 0;
var markets_1 = __importDefault(require("../../services/markets"));
var neko_1 = require("../../services/neko");
var errors_1 = require("./errors");
var Result_1 = __importDefault(require("../../Result"));
/**
 * Markets data
 */
var MarketsController = /** @class */ (function () {
    function MarketsController() {
    }
    /**
     * Retreives hourly market charts
     * @param coins - array of coin tickers
     * @param quotes - array of fiat currencies
     * @param from - requested start time of market data
     * @param to - requested end time of market data
     * @returns - TMarketsData
     */
    MarketsController.getChartsHourly = function (coins, quotes, from, to) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, markets_1.default.ohlc.hourly(coins, quotes, from, to)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_FETCH_HOURLY_DATA)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Retreives daily market charts
     * @param coins - array of coin tickers
     * @param quotes - array of fiat currencies
     * @param from - requested start time of market data
     * @param to - requested end time of market data
     * @returns - TMarketsData
     */
    MarketsController.getChartsDaily = function (coins, quotes, from, to) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, markets_1.default.ohlc.daily(coins, quotes, from, to)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_FETCH_DAILY_DATA)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Retreives minutely market charts
     * @param coins - array of coin tickers
     * @param quotes - array of fiat currencies
     * @param from - requested start time of market data
     * @param to - requested end time of market datas
     * @returns - TMarketsData
     */
    MarketsController.getChartsMinutely = function (coins, quotes, from, to) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, markets_1.default.ohlc.minutely(coins, quotes, from, to)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_3 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_FETCH_MINUTELY_DATA)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Retreives weekly market charts
     * @param coins - array of coin tickers
     * @param quotes - array of fiat currencies
     * @param from - requested start time of market data
     * @param to - requested end time of market datas
     * @returns - TMarketsData
     */
    MarketsController.getChartsWeekly = function (coins, quotes, from, to) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, markets_1.default.ohlc.weekly(coins, quotes, from, to)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_4 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_FETCH_WEEKLY_DATA)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @deprecated Depreciated, replaced by `getChartsHourly`
     */
    MarketsController.getMarketsCharts = function (coins) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getChartsHourly(coins)];
            });
        });
    };
    /**
     * Gets all coin tickers
     * @returns TTickersData
     */
    MarketsController.getCoinTickers = function (byProtocol) {
        return __awaiter(this, void 0, void 0, function () {
            var byId, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, markets_1.default.coin.tickers(byProtocol)];
                    case 1:
                        byId = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(byId)];
                    case 2:
                        error_5 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_FETCH_TICKER_DATA)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Retrieves historical rates for a list of timestamps
     *
     * @param assetId - The internal ID of assets in the backend. Examples: BTC, BCH, ETH, SLP token IDs
     * @param timestamps - An array of timestamps to query historical rates
     * @param expressedAssetId - The asset ID used to express rates. Example: USD
     * @returns THistoricalRate on successful query
     */
    MarketsController.getHistoricalRates = function (assetId, timestamps, expressedAssetId) {
        if (expressedAssetId === void 0) { expressedAssetId = 'USD'; }
        return __awaiter(this, void 0, void 0, function () {
            var data, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.markets.getHistoricalRates(assetId, timestamps, expressedAssetId)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_6 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_FETCH_RATES_DATA)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Retrieves historical rate for a single timestamp
     *
     * @param assetId - The internal ID of assets in the backend. Examples: BTC, BCH, ETH, SLP token IDs
     * @param timestamp - A timestamp to query historical rates
     * @param expressedAssetId - The asset ID used to express rates. Example: USD
     * @returns number on successful query
     */
    MarketsController.getHistoricalRate = function (assetId, timestamp, expressedAssetId) {
        if (expressedAssetId === void 0) { expressedAssetId = 'USD'; }
        return __awaiter(this, void 0, void 0, function () {
            var data, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.markets.getHistoricalRates(assetId, [timestamp], expressedAssetId)];
                    case 1:
                        data = _a.sent();
                        if (data && data[timestamp])
                            return [2 /*return*/, Result_1.default.ok(data[timestamp])];
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_FETCH_RATES_DATA)];
                    case 2:
                        error_7 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_FETCH_RATES_DATA)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Ticker list by token platform
     * @param tokenPlatform - ardor | bitshares | counterparty | ethereum | nebulas | neo | omni | qtum | rsk-smart-bitcoin | slp | stellar | waves
     * @returns TTokenData
     */
    MarketsController.getTickersByPlatform = function (tokenPlatform) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, markets_1.default.coin.platform(tokenPlatform)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_8 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_FETCH_TOKEN_PLATFORM_DATA)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Tickers by coin type
     * @param coinType - coin | token
     * @returns TTokenData
     */
    MarketsController.getTickersByType = function (coinType) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, markets_1.default.coin.coinType(coinType)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_9 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_FETCH_COIN_TYPE_DATA)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets exchange rate of base currency
     * @param baseCurrency - USD | BCH | BTC
     * @returns - TRatesData
     */
    MarketsController.getRates = function (baseCurrency) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, markets_1.default.rates.rates(baseCurrency)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_10 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_FETCH_RATES_DATA)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Equivalent of currency in quoteCurrency
     * @param currency - BCH | BTC | ETH | USDT | USDC
     * @param quoteCurrency - USD
     * @returns - TRatesData
     */
    MarketsController.convertRates = function (currency, quoteCurrency) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, markets_1.default.rates.converter(currency, quoteCurrency)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_11 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_FETCH_CONVERSION_RATES_DATA)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Historical Metadata (Market Cap, 24H Volume, Supply)
     * @param symbol - A single coin or token symbol
     * @param quoteCurrencies - Comma-delimited list of quote currencies
     * @returns - THistoricalMetadata
     */
    MarketsController.getHistoricalMetadata = function (symbol, quoteCurrencies) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, markets_1.default.metadata.historical(symbol, quoteCurrencies)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_12 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_FETCH_HISTORICAL_METADATA)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Aggregated 24h metadata (marketcap and volume)
     * @returns TAggregatedMetadata
     */
    MarketsController.getAggregatedMetadata = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, markets_1.default.metadata.aggregated()];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_13 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_FETCH_AGGREGATED_METADATA)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Exchanges summary
     * @returns TExchangesData
     */
    MarketsController.getExchangesSummary = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, markets_1.default.exchanges.summary()];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_14 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_FETCH_EXCHANGES_SUMMARY)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Fetch Movers
     * @returns TMoverslist
     */
    MarketsController.getMovers = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, markets_1.default.movers.gainerslosers()];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_15 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_FETCH_MOVERS_DATA)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get all time highs and lows
     * @returns TAthlData
     */
    MarketsController.getAthl = function (coin) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, markets_1.default.athl.athl(coin)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_16 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_FETCH_ATHL_DATA)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return MarketsController;
}());
exports.MarketsController = MarketsController;
